import { PspRules } from "@CommonTypes/backend/PspRules";
import { PALLET_DEFAULT_MAX_SKUS } from "@CommonUtils/pog/pallet";

// Shared with the backend, which tells an untouched switch from the merchant's by them.
export { DEFAULT_WEIGHT_RULES, defaultPspRules } from "@CommonUtils/pog/defaultPspRules";

/**
 * Seeded into the heavy-rule form, not into `defaultPspRules.heavy_rule` — the
 * rule is null until the user supplies `max_deck_y`, which has no default worth
 * guessing. Lives here so every weight number the UI seeds is in one file.
 */
export const DEFAULT_HEAVY_ITEM_THRESHOLD_G = 4536;

/**
 * Today's pallet request: PALLET_DEFAULT_MAX_SKUS products a pallet, each
 * stacked to its own fixture. Sent with store generation only (base generation
 * stands no pallets), and at these values the backend's request is unchanged.
 */
export const DEFAULT_PALLET_RULES: NonNullable<PspRules["pallets"]> = {
  max_products_per_pallet: PALLET_DEFAULT_MAX_SKUS,
  max_stack_height: null,
};

/**
 * The weekly movement floor seeded when "leave out slow movers" is switched on
 * (`range.min_candidate_quantity`); 7-Eleven Malaysia's standing threshold.
 * The switch itself defaults off, so `defaultPspRules` carries no floor.
 */
export const DEFAULT_MIN_CANDIDATE_QUANTITY = 0.25;
